import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Color, Grid, Type } from '../app/StyleGuide';

const TabWrapper = styled.li<{ active: boolean }>`
  &:hover {
    border-bottom: 3px solid ${Color.Gray._30};
  }

  button {
    border: 0;
    background: none;
    padding: ${Grid._4} ${Grid._5};
    width: 100%;
    text-align: center;
    white-space: nowrap;
    font-size: ${Type.Scale._4};
    color: ${Type.Color.medium};

    span {
      color: ${Color.Secondary._50};
    }
  }

  ${props =>
    props.active &&
    `
      border-bottom: 3px solid ${Color.Orange._50};

      > button span {
        color: ${Type.Color.mediumDark};
        font-weight: ${Type.Weight.semibold};
      }
  `}
`;

const TabIcon = styled.span``;

const TabName = styled.span`
  display: none;
  margin-left: ${Grid._3};
  white-space: nowrap;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    display: inline;
  }
`;

type TabProps = {
  active: boolean;
  iconClass: string;
  name: string;
  onClick: () => void;
};

// The aria-label on the icon is to provide accessibility while on mobile
export const Tab = ({ active, iconClass, name, onClick }: TabProps) => (
  <TabWrapper role="tab" active={active} aria-selected={active}>
    <button onClick={onClick}>
      <TabIcon aria-label={name} className={iconClass} />
      <TabName>{name}</TabName>
    </button>
  </TabWrapper>
);

export const TabContainer = styled.ul.attrs({ role: 'tablist' })`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  list-style: none;
  margin: 0;
  padding: 0;

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    grid-template-columns: repeat(4, minmax(min-content, 180px));
  }
`;
